import { StreamActions } from "@hotwired/turbo"

// 关闭模态框动作
StreamActions.close_modal = function() {
  window.dispatchEvent(new CustomEvent("modal:close"))
  const dialogs = document.querySelectorAll("dialog[open]")
  dialogs.forEach(dialog => {
    dialog.close()
  })
  document.body.classList.remove("overflow-hidden")
}

// 刷新页面动作 (Turbo 方式)
StreamActions.refresh_page = function() {
  console.log("[Turbo] Refreshing page via custom action...")
  const url = window.location.href
  if (window.Turbo) {
    window.Turbo.visit(url, { action: "replace" })
  } else {
    window.location.reload()
  }
}
// 全局监听排序成功事件，自动刷新页面
document.addEventListener("sortable:success", () => { 
  console.log("Sort successful, refreshing..."); 
  if (window.Turbo) { Turbo.visit(window.location.href, { action: "replace" }); } else { window.location.reload(); }
});
